module.exports = __webpack_public_path__ + "c2427c2c0d0e1eecc62b1eb5057e6180.svg";